<template>
  <Section>
    <template #header>
      <div class="flex items-center gap-2 text-dark-neutral-500">
        <span class="material-symbols-outlined">compost</span>
        <h2 class="font-semibold">Lifecycle</h2>
      </div>
    </template>
    <div class="px-6 py-4 space-y-2">
      <div
        class="p-5 bg-light-neutral-200 border-l-4 border-primary-500 text-dark-neutral-900"
      >
        <p class="font-semibold">
          As you enter device properties, the AI will automatically update the
          applicable lifecycle phases.
        </p>
        <span>
          Alternatively (not recommended), you can define custom phases
          manually.
        </span>
      </div>
      <table
        class="w-full table-fixed border border-mid-neutral-50 bg-white text-left border-collapse"
      >
        <thead class="bg-gray-100 text-sm text-mid-neutral-500">
          <tr>
            <th class="py-4 px-7.5 border-b border-mid-neutral-50 w-[200px]">
              Phase
            </th>
            <th class="py-4 px-7.5 border border-mid-neutral-50">
              Description
            </th>
            <th
              class="py-4 px-7.5 border-b border-mid-neutral-50 text-center w-[120px]"
            >
              Status
            </th>
          </tr>
        </thead>
        <tbody class="text-dark-neutral-500">
          <tr
            v-for="(phase, index) in phases"
            :key="index"
            class="hover:bg-gray-50 transition border-b border-mid-neutral-50"
          >
            <td class="px-7.5 py-3.5 gap-3">
              <div class="flex gap-2.5 items-center">
                <span class="material-symbols-outlined">
                  {{ phase.icon }}
                </span>
                <span>{{ phase.name }}</span>
              </div>
            </td>
            <td class="px-4 py-3.5 border-x border-mid-neutral-50">
              <input
                type="text"
                v-model="phase.description"
                class="w-full rounded px-2 py-1 text-sm disabled:bg-gray-100 outline-none"
                placeholder="Enter description"
              />
            </td>
            <td class="px-7.5 py-3.5 text-center">
              <Switch
                :model-value="phase.isEnabled"
                @update:model-value="
                  (value: boolean) => setPhaseEnabled(phase.id, !!value)
                "
                :disabled="phase.id === PhaseId.USE"
              >
                <template #icon v-if="phase.id === PhaseId.USE">
                  <component
                    v-if="phase.isEnabled"
                    :is="LockClosedIcon"
                    class="w-4 h-4 text-green-500"
                  />
                </template>
              </Switch>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </Section>
</template>

<script setup lang="ts">
import { LockClosedIcon } from "@heroicons/vue/24/solid";

import { Switch } from "ui-components";
import Section from "components/Section.vue";
import { lifecyclePhasesState, PhaseId } from "states/lifecyclePhases";

const { phases, setPhaseEnabled } = lifecyclePhasesState();
</script>
